<template>
  <div class="add-to-bag" data-testid="add-to-bag">
    <Button width="full" @click="handleAddToBag">
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "AddToBag",
  components: {
    Button,
  },
  emits: ["clicked"],
  data() {
    return {
      clicked: false,
    };
  },
  computed: {
    ...mapState("product", ["selectedVariant", "product"]),
    availableForSale() {
      if (!this.selectedVariant) {
        return true;
      }

      return this.selectedVariant?.availableForSale;
    },
    buttonText() {
      if (this.clicked && !this.selectedVariant) {
        return "Select Size";
      } else if (this.availableForSale) {
        return "Add to bag";
      } else {
        return "Sold out. Notify me when back";
      }
    },
  },
  methods: {
    ...mapActions("cart", ["addCartItem", "setCartOpen"]),
    ...mapActions("add-to-bag", ["openStockNotification"]),
    handleAddToBag() {
      this.clicked = true;

      if (!this.selectedVariant) {
        return;
      }

      this.$emit("clicked");

      if (!this.selectedVariant?.availableForSale) {
        return this.openStockNotification({
          product: this.product,
          variant: this.selectedVariant,
        });
      }

      this.addCartItem({
        productId: this.product.id,
        variantId: this.selectedVariant.id,
        quantity: 1,
      });

      this.setCartOpen(true);
    },
  },
};
</script>
